import { PositionPlatformRuleDictionaryItem } from '@/models/dictionary/positionPlatformRule';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IPositionPlatformRuleDictionaryApi } from '@/types';

export const usePositionPlatformRuleDictionary = defineStore('positionPlatformRuleDictionary', () => {
    const itemsAll = shallowRef<PositionPlatformRuleDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: IPositionPlatformRuleDictionaryApi[]) {
        itemsAll.value = data.map((item) => new PositionPlatformRuleDictionaryItem(item));
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
